var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M16 4h4v4m-6 2l6-6M8 20H4v-4m0 4l6-6"
    }, null, -1)
  ]));
}
__name(render, "render");
const arrowsDiagonal = markRaw({ name: "tabler-arrows-diagonal", render });
export {
  arrowsDiagonal as default
};
//# sourceMappingURL=arrows-diagonal.js.map
